import { render } from "./SolicitacaoSaidaCprodView.vue?vue&type=template&id=907bc3aa"
import script from "./SolicitacaoSaidaCprodView.vue?vue&type=script&lang=js"
export * from "./SolicitacaoSaidaCprodView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__